//api 接口路径
export default {
  BaseAPI: "/cat/api/v1",
  BaseAPI2: "/apis/v1",
  BaseAPI3: "/cat",
  BaseAPI4: "/api/v1",
  BaseAPI5: "",
  PaymentAPI: "/payment",
  UserAPI: "https://accounts.newtranx.com/api/v1/",
};
